<div
        class="form-group"
        [formGroup]="OBJ_form_group"
        [ngClass]="{'has-error': isInvalid()}">
    <label class="col-lg-2 control-label" [ngClass]="{'tgi-required': isRequired()}">{{getLabelName()|translate}}
        <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
    <div *ngIf="BOO_image_edit" class="col-lg-8">
        <div class="img-wrapper img-circle" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (click)="OBJ_file_upload.click()">
            <span *ngIf="!BOO_image_loaded"><i class="fa fa-picture-o"></i><br />{{"oFile.sDropImage"|translate}}</span>
            <img *ngIf="BOO_image_loaded" class="img-circle" [src]="this.STR_url"/>
        </div>
        <div class="upload-wrapper">
            <button type="button" class="btn btn-primary btn-circle"><i class="fa fa-upload"></i></button>
            <input
                    #OBJ_file_upload
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/gif"
                    (change)="fileChangeListener($event)"
                    title="{{'upload'|translate}}"/>
            <button type="button" *ngIf="!isRequired()" class="btn btn-danger btn-circle clear" title="{{'delete'|translate}}" (click)="reset()"><i class="fa fa-trash-o"></i></button>
        </div>
	    <div class="tig-hint" *ngIf="OBJ_field_config.note">
		    <span>{{ OBJ_field_config.note|translate}}</span>
	    </div>
        <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
    </div>
    <div *ngIf="!BOO_image_edit" class="col-lg-8">
        <div class="img-wrapper img-circle">
            <span *ngIf="!BOO_image_loaded"><i class="fa fa-picture-o"></i><br />{{"oFile.sNoImage"|translate}}</span>
            <img *ngIf="BOO_image_loaded" class="img-circle" [src]='this.STR_url'/>
        </div>
    </div>
</div>
